export class BdPermissionsCompanyStore {

  constructor(
    private readonly _baseUrl: string
  ) {
  }

  public base(): string {
    return this._baseUrl;
  }

  public getAll(): string {
    return `${this.base()}/companies/`;
  }

  public getById(companyId: string): string {
    return `${this.base()}/companies/${companyId}`;
  }

  public getGroupsByCompanyId(companyId: string): string {
    return `${this.base()}/companies/${companyId}/groups`;
  }

  public getUsersByCompanyId(companyId: string): string {
    return `${this.base()}/companies/${companyId}/users`;
  }
}
